import React from 'react'
import ObjectField from 'App/components/fields/ObjectField'
import Fields from 'orionjs-react-autoform/lib/Fields'
import AutoForm from 'App/components/AutoForm'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

export default function ValidationField({option}) {
  const {schemaToReleaseOrderOption} = useQuery({
    query: gql`
      query getSchemaToReleaseOrderOption($option: String) {
        schemaToReleaseOrderOption(option: $option)
      }
    `,
    variables: {option}
  })

  if (!schemaToReleaseOrderOption) return null

  return (
    <Field fieldName="values" type={ObjectField}>
      <Fields getFieldComponent={AutoForm.getFieldComponent} params={schemaToReleaseOrderOption} />
    </Field>
  )
}
